// ISO-8601 Z 문자열 → 기기 로컬 표시. 계산은 하지 않는다(0.5절 시각·날짜 규칙).
const dateTime = new Intl.DateTimeFormat("ko-KR", { dateStyle: "medium", timeStyle: "short" });
const dateOnly = new Intl.DateTimeFormat("ko-KR", { dateStyle: "medium" });

export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : dateTime.format(d);
}

export function formatDate(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : dateOnly.format(d);
}

const pad2 = (n: number) => String(n).padStart(2, "0");

/** 시안 표기 `2026.10.14`(기기 로컬). 내역 날짜 그룹 헤더·그룹 키. */
export function formatDateDot(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : `${d.getFullYear()}.${pad2(d.getMonth() + 1)}.${pad2(d.getDate())}`;
}

/** 시안 표기 `2026.10.14 21:42`(기기 로컬, 24시간). 결제 완료 영수증. */
export function formatDateTimeDot(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : `${formatDateDot(iso)} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}
